// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import BlogCategories from "@store/Library/Components/Blog/Common/BlogCategories";
import BlogDate from "@store/Library/Components/Blog/Common/BlogDate";
import BlogImage, { BlogImageStyles } from "@store/Library/Components/Blog/Common/BlogImage";
import BlogSummary from "@store/Library/Components/Blog/Common/BlogSummary";
import BlogTitle from "@store/Library/Components/Blog/Common/BlogTitle";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import breakpointUtility from "@toolkit/Framework/Common/Utilities/breakpoint";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    publicationDate: Date;
    hideHourMinutes: boolean;
    previewImage: string;
    categoriesList?: string[];
    blogSummary: string;
    blogLink?: string;
    isArchived: boolean;
    extendedStyles?: BlogListTileStyles;
}

type Props = OwnProps;

export interface BlogListTileStyles {
    tileWrapper?: InjectableCss;
    detailsWrapper?: InjectableCss;
}

export const blogListTileStyles: BlogListTileStyles = {
    tileWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    detailsWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
};

export const blogImageStyles: BlogImageStyles = {
    wrapper: {
        css: css`
            ${breakpointUtility("md", "up")} {
                &:hover img,
                &:focus img {
                    scale: 1.1;
                }
            }
        `,
    },
    image: {
        css: css`
            transition: ${transitionHoverStyles("scale")};
        `,
    },
};

const BlogListTile = ({
    title,
    publicationDate,
    hideHourMinutes,
    previewImage,
    categoriesList,
    blogSummary,
    blogLink,
    isArchived,
    extendedStyles,
}: Props) => {
    const styles = useMergeProps(blogListTileStyles, extendedStyles);

    return (
        <StyledWrapper {...styles.tileWrapper}>
            {previewImage && (
                <BlogImage
                    previewImage={previewImage}
                    altText={title}
                    blogLink={blogLink}
                    extendedStyles={blogImageStyles}
                />
            )}
            <StyledWrapper {...styles.detailsWrapper}>
                <BlogTitle title={title} blogLink={blogLink} />
                <BlogDate publicationDate={publicationDate} hideHourMinutes={hideHourMinutes} />
                <BlogSummary blogSummary={blogSummary} />
                <BlogCategories categoriesList={categoriesList} isArchived={isArchived} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default BlogListTile;
